import axiosInstance from "./axiosInstance";

const WITHDRAWAL_BASE_URL = "/merchant";
const TRANSACTION_BASE_URL = "/transaction";
const REPORTS_BASE_URL = "/reports/transactions-pdf";
const RESEND_OTP_URL = "/merchant/resend-otp";
const MANAGE_TRANSACTION_BASE_URL = "/management/transactions";

const transactionService = {
  listAllTransactions: async ({
    searchQuery,
    startDate,
    endDate,
    serviceCodes,
    page = 0,
    size = 10,
  }) => {
    const params = new URLSearchParams();
    if (searchQuery) params.append("searchQuery", searchQuery);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    serviceCodes?.forEach((code) => params.append("serviceCodes", code));
    params.append("page", page.toString());
    params.append("size", size.toString());

    const response = await axiosInstance.get(
      `${TRANSACTION_BASE_URL}?${params.toString()}`,
    );
    return response.data;
  },

  exportTransactionsPdf: async ({
    searchQuery,
    startDate,
    endDate,
    serviceCodes,
  } = {}) => {
    const params = new URLSearchParams();
    if (searchQuery) params.append("searchQuery", searchQuery);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    serviceCodes?.forEach((code) => params.append("serviceCodes", code));

    const queryString = params.toString();
    const url = `${REPORTS_BASE_URL}?${queryString}`;

    const response = await axiosInstance.get(url, {
      responseType: "blob",
    });
    return response;
  },

  exportManagementTransactionsPdf: async ({
    searchQuery,
    startDate,
    endDate,
    serviceCodes,
    merchantId,
    page = 0, 
    size = 10,
  } = {}) => {
    const params = new URLSearchParams();
    if (searchQuery) params.append("searchQuery", searchQuery);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    serviceCodes?.forEach((code) => params.append("serviceCodes", code));
    if (merchantId) params.append("merchantId", merchantId);
    params.append("page", page.toString());
    params.append("size", size.toString());

    const queryString = params.toString();
    const url = `${MANAGE_TRANSACTION_BASE_URL}/export?${queryString}`;

    const response = await axiosInstance.get(url, {
      responseType: "blob",
    });
    return response;
  },

  authorizeWithdrawal: async (request) => {
    const response = await axiosInstance.post(
      `${WITHDRAWAL_BASE_URL}/authorize`,
      request,
    );
    return response.data;
  },

  resendAuthorizationCode: async (transactionId) => {
    return await axiosInstance.post(
      `${RESEND_OTP_URL}?transactionId=${encodeURIComponent(transactionId)}`,
    );
  },

  getRecentPayouts: async (limit) => {
    const params = new URLSearchParams();
    if (limit != null && limit !== "") {
      params.append("limit", String(limit));
    }
    const url = `${TRANSACTION_BASE_URL}/recent?${params.toString()}`;
    const response = await axiosInstance.get(url);
    return response.data;
  },

  getTotalRevenue: async () => {
    const response = await axiosInstance.get(
      `${TRANSACTION_BASE_URL}/total-revenue`,
    );
    return response.data;
  },

  getTotalDisbursments: async () => {
    const response = await axiosInstance.get(
      `${TRANSACTION_BASE_URL}/total-disbursed`,
    );
    return response.data;
  },

  getManagementTransactions: async ({
    searchQuery,
    startDate,
    endDate,
    serviceCodes,
    merchantId,
    page = 0,
    size = 10,
  } = {}) => {
    const params = new URLSearchParams();
    if (searchQuery) params.append("searchQuery", searchQuery);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    serviceCodes?.forEach((code) => params.append("serviceCodes", code));
    if (merchantId) params.append("merchantId", merchantId);
    params.append("page", page.toString());
    params.append("size", size.toString());

    const reponse = await axiosInstance.get(
      `${MANAGE_TRANSACTION_BASE_URL}?${params.toString()}`,
    );
    return reponse.data;
  },

  reassignTransaction: async ({ merchantId, transactionId, reason }) => {
    const payload = { merchantId, transactionId, reason };
    const response = await axiosInstance.post(
      `${MANAGE_TRANSACTION_BASE_URL}/re-assignment`,
      payload,
    );
    return response.data;
  },
};

export default transactionService;
